function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ffffff } \n\t\t.shp1 { fill: none;stroke: #000000;stroke-width: 20.625 } \n\t\t.shp2 { fill: #000708 } \n\t\t.shp3 { fill: #000000 } \n\t\t.shp4 { fill: none;stroke: #000c11;stroke-width: 27.5 } \n\t\t.shp5 { fill: #107583 } \n\t\t.shp6 { fill: none;stroke: #000c11;stroke-width: 13.75 } \n\t\t.shp7 { fill: none;stroke: #000c11;stroke-width: 3.438 } \n\t");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "a3L9IWfeM",
  className: "shp0",
  d: "M320.91,112.97c-139.17,0 -252.14,88.76 -252.14,198.07c0,109.31 112.97,198.07 252.14,198.07c139.17,0 252.16,-88.76 252.16,-198.07c0,-109.31 -112.99,-198.07 -252.16,-198.07z"
}), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "a3L9IWfeM",
  className: "shp1",
  d: "M320.91,112.97c-139.17,0 -252.14,88.76 -252.14,198.07c0,109.31 112.97,198.07 252.14,198.07c139.17,0 252.16,-88.76 252.16,-198.07c0,-109.31 -112.99,-198.07 -252.16,-198.07z"
}))), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "a2VBWt1BUD",
  className: "shp2",
  d: "M399.96,283.8c23.07,19.35 55.52,18.73 72.39,-1.37c16.88,-20.11 11.84,-52.16 -11.22,-71.53c-23.08,-19.35 -55.52,-18.75 -72.39,1.38c-16.88,20.11 -11.86,52.16 11.22,71.53z"
})), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "e23UBtCqbt",
  className: "shp3",
  d: "M60.76,93.53c-33.57,19.39 -47.61,58.01 -31.33,86.21c16.28,28.2 56.75,35.35 90.34,15.98c33.57,-19.39 47.61,-58.02 31.32,-86.21c-16.28,-28.2 -56.75,-35.37 -90.32,-15.98z"
})), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "b3slEKYBBo",
  className: "shp3",
  d: "M579.45,93.53c-33.57,-19.39 -74.04,-12.22 -90.34,15.98c-16.28,28.19 -2.23,66.82 31.33,86.21c33.57,19.37 74.04,12.22 90.32,-15.98c16.29,-28.2 2.25,-66.83 -31.32,-86.21z"
})), React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "a5gotkI3C",
  className: "shp4",
  d: "M351.13,301.77h-26.43h-33.98"
}))), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "d7DT673bqx",
  className: "shp2",
  d: "M240.25,283.8c23.08,-19.37 28.1,-51.42 11.22,-71.53c-16.88,-20.13 -49.31,-20.73 -72.39,-1.38c-23.07,19.37 -28.1,51.42 -11.22,71.53c16.88,20.11 49.31,20.73 72.39,1.37z"
})), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "dgNxLG4Lu",
  className: "shp0",
  d: "M223.18,231.89c-7.46,0 -13.51,8.65 -13.51,19.32c0,10.66 6.05,19.3 13.51,19.3c7.46,0 13.53,-8.65 13.53,-19.3c0,-10.67 -6.07,-19.32 -13.53,-19.32z"
})), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "budnSAHI5",
  className: "shp0",
  d: "M417.02,231.89c-7.46,0 -13.53,8.65 -13.53,19.32c0,10.66 6.07,19.3 13.53,19.3c7.46,0 13.51,-8.65 13.51,-19.3c0,-10.67 -6.05,-19.32 -13.51,-19.32z"
})), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "c4Jf2913AE",
  className: "shp5",
  d: "M447.22,320.9c-18.99,0 -34.37,15.38 -34.37,34.38c0,40.63 0,128.15 0,168.78c0,18.99 15.38,34.38 34.38,34.38c34.07,0 101.89,0 135.95,0c18.99,0 34.38,-15.38 34.38,-34.37c0,-40.63 0,-128.15 0,-168.78c0,-18.99 -15.38,-34.37 -34.37,-34.37c-34.07,0 -101.89,0 -135.95,0z"
}), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "c4Jf2913AE",
  className: "shp6",
  d: "M447.22,320.9c-18.99,0 -34.37,15.38 -34.37,34.38c0,40.63 0,128.15 0,168.78c0,18.99 15.38,34.38 34.38,34.38c34.07,0 101.89,0 135.95,0c18.99,0 34.38,-15.38 34.38,-34.37c0,-40.63 0,-128.15 0,-168.78c0,-18.99 -15.38,-34.37 -34.37,-34.37c-34.07,0 -101.89,0 -135.95,0z"
}))), React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "a120KJdL1u",
  className: "shp0",
  d: "M583.95,394.76l-25.49,-30.27l-64.8,76.95l-21.73,-25.8l-25.49,30.27l47.21,56.08l25.49,-30.27v-0.02z"
})), React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "c3nBGE8rua",
  className: "shp7",
  d: "null"
}))), React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "a3sX9XGelw",
  className: "shp6",
  d: "M266.91,353.4c16.53,29.55 34.55,29.55 54,0"
}))), React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "b3HwEAP7C8",
  className: "shp6",
  d: "M320.91,353.4c19.47,29.55 37.47,29.55 54.02,0"
}))), React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "c5wk8Vntp",
  className: "shp6",
  d: "M320.91,359.8v-28.57v-33.31"
}))), React.createElement("g", {
  id: "Layer"
}, React.createElement("g", {
  id: "Layer"
}, React.createElement("path", {
  id: "b6tzDSAOHZ",
  className: "shp7",
  d: "null"
})))));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.06501691.svg";
export { ForwardRef as ReactComponent };